import React, { useEffect } from 'react';
import { View, StyleSheet, Text } from 'react-native';
import LinearGradient from 'react-native-linear-gradient';
import Animated, {
  useSharedValue,
  useAnimatedStyle,
  withTiming,
  Easing,
} from 'react-native-reanimated';
import FastImageView from '../../components/FastImageView';

const RoutineHappinessProgressBar = ({
  barColor,
  height,
  emojiUrl,
  dateLabel,
}) => {
  const outerBarHeight = 100;
  const outerHeight = useSharedValue(0);
  const innerHeight = useSharedValue(0);
  const animatedEmojiPosition = useSharedValue(100);

  useEffect(() => {
    outerHeight.value = withTiming(outerBarHeight, {
      duration: 1000,
      easing: Easing.out(Easing.ease),
    });

    innerHeight.value = withTiming(height, {
      duration: 1000,
      easing: Easing.out(Easing.ease),
    });

    animatedEmojiPosition.value = withTiming(0, {
      duration: 1000,
      easing: Easing.out(Easing.ease),
    });
  }, [outerBarHeight, height]);

  const outerBarAnimatedStyle = useAnimatedStyle(() => ({
    height: outerHeight.value,
  }));

  const innerBarAnimatedStyle = useAnimatedStyle(() => ({
    height: innerHeight.value,
  }));

  const emojiAnimatedStyle = useAnimatedStyle(() => ({
    transform: [{ translateY: animatedEmojiPosition.value }],
  }));

  return (
    <View style={styles.progressContent}>
      <Animated.View style={[styles.barEmoji, emojiAnimatedStyle]}>
        <FastImageView source={{ uri: emojiUrl }} style={styles.emojiImage} />
      </Animated.View>
      <Animated.View style={[styles.outerProgressBar, outerBarAnimatedStyle]}>
        <Animated.View
          style={[styles.innerProgressFill, innerBarAnimatedStyle]}
        >
          <LinearGradient colors={barColor} style={styles.barStyle} />
        </Animated.View>
      </Animated.View>
      <Text style={styles.dateLabel}>{dateLabel}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  progressContent: {
    alignItems: 'center',
    marginHorizontal: 10,
  },
  outerProgressBar: {
    width: 40,
    height: 100,
    borderRadius: 8,
    backgroundColor: '#f0f0f0',
    marginVertical: 10,
    overflow: 'hidden',
    justifyContent: 'flex-end',
  },
  innerProgressFill: {
    width: 32,
    alignSelf: 'center',
    position: 'absolute',
    bottom: 0,
  },
  barEmoji: {
    position: 'absolute',
    zIndex: 1,
  },
  emojiImage: {
    width: 30,
    height: 30,
  },
  dateLabel: {
    fontSize: 12,
    color: '#979BAA',
    marginTop: 5,
    fontWeight: '500',
    fontFamily: 'Roboto-Regular',
  },
  barStyle: {
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    borderRadius: 8,
  },
});

export default RoutineHappinessProgressBar;
